import PropTypes from 'prop-types';
import { startCase } from 'lodash';
// @mui
import { Stack, Link, TableRow, TableCell, Typography, Tooltip } from '@mui/material';
// components
import { fDateTime } from '../../../../../utils/formatTime';
import Iconify from '../../../../../components/Iconify';
import { getFileNameFromUrl } from '../../../../../utils/common';

// ----------------------------------------------------------------------

ImmersveKYCTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
};

export default function ImmersveKYCTableRow({ row, selected }) {
  const { id, user, created_date, modified_date, funding_source_id, account_id, kyc_status } = row;

  const getStatusIcon = (value) => {
    if (value === 'ok') return 'eva:checkmark-circle-fill';
    if (value === 'pending') return 'eva:clock-outline';
    if (value === 'blocked') return 'eva:close-circle-fill';
    if (value === 'action-required') return 'eva:alert-circle-fill';
    return 'eva:clock-outline';
  };

  const getStatusColor = (status) => {
    if (status === 'ok') return 'success.main';
    if (status === 'blocked') return 'error.main';
    return 'warning.main';
  };

  return (
    <TableRow hover selected={selected}>
      <TableCell padding="checkbox">{id}</TableCell>
      <TableCell sx={{ display: 'flex', alignItems: 'left' }}>
        <Stack direction={'column'}>
          <Typography variant="subtitle2" noWrap>
            {user?.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.disabled' }}>
            {user?.email}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell align="left">{user?.country?.name}</TableCell>
      <TableCell align="left">{`${user?.dial_code} ${user?.phone_number}`}</TableCell>
      <TableCell align="left">{fDateTime(created_date)}</TableCell>
      <TableCell align="left">{fDateTime(modified_date)}</TableCell>
      <TableCell align="left">{funding_source_id || '--'}</TableCell>
      <TableCell align="center">{account_id || '--'}</TableCell>
      <TableCell align="center">
        <Tooltip title={kyc_status?.display} placement="top" arrow>
          <span>
            <Iconify
              icon={getStatusIcon(kyc_status?.value)}
              sx={{
                width: 20,
                height: 20,
                color: getStatusColor(kyc_status?.value),
              }}
            />
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}
